import React from 'react';
import { motion } from 'framer-motion';
import { WrenchIcon, CarIcon, SearchIcon } from 'lucide-react';
const features = [{
  icon: <WrenchIcon className="w-7 h-7 text-brand-accent" data-id="element-41" />,
  title: 'Advanced diagnostic tools and OEM-quality parts',
  body: 'Modern vehicles require specialized diagnostic equipment and manufacturer service data. Our technicians use advanced diagnostic tools and OEM-quality parts comparable to those used by dealerships — giving your vehicle the same level of technical care without dealership-level pricing.'
}, {
  icon: <CarIcon className="w-7 h-7 text-brand-accent" data-id="element-42" />,
  title: 'Expertise across all makes and models',
  body: 'Our technicians work on domestic, European, and Asian vehicles every day. Instead of focusing on a single brand, we diagnose and repair hundreds of different vehicles each year, giving us broad experience with the problems drivers actually encounter.'
}, {
  icon: <SearchIcon className="w-7 h-7 text-brand-accent" data-id="element-43" />,
  title: 'Root-cause diagnostics',
  body: 'Many expensive repairs begin by replacing the part most commonly associated with a fault code. We verify the full system first. That means identifying the real cause before replacing expensive components — which often leads to a much simpler repair.'
}];
export function DealershipCapability() {
  return <section className="py-20 px-4 bg-white" data-id="element-44">
      <div className="max-w-5xl mx-auto" data-id="element-45">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-46">
          <span className="uppercase tracking-widest text-sm font-bold text-brand-accent mb-4 block" data-id="element-47">
            Why drivers choose independent service
          </span>
          <h2 className="font-heading uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl font-extrabold text-brand-dark" data-id="element-48">
            Your car gets the same level of technical care — without dealership
            overhead.
          </h2>
        </motion.div>

        <div className="space-y-12" data-id="element-49">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex gap-6 items-start" data-id="element-50">
              <div className="bg-brand-light p-3 rounded-xl border border-gray-200 flex-shrink-0 mt-1" data-id="element-51">
                {feature.icon}
              </div>
              <div data-id="element-52">
                <h3 className="font-heading uppercase tracking-wide text-xl font-bold text-brand-dark mb-3" data-id="element-53">
                  {feature.title}
                </h3>
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-54">
                  {feature.body}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}